import { FacilityStatus } from '../facilities/facility.model';
import { PagedRequestDto } from './../paged-request.model';
export interface CorporationSearchDto extends PagedRequestDto {
  isActive?: boolean | null;
  status?: FacilityStatus;
  stateCode?: string;
}
